import ENV from '@/constants/env'

export function getCookieDomain(): string {
    const currentDomain = window.location.hostname

    if (ENV.environment === `qa` && currentDomain.endsWith(`.amplifyapp.com`)) {
        return currentDomain
    }

    return `.${ENV.helmDomain()}`
}
